import React from 'react';
import {
  Button,
} from 'reactstrap';
import numeral from 'numeral';
import FontAwesome from 'react-fontawesome';
import moment from 'moment';
import { Link } from 'react-router-dom';

const Loan = (item) => {
  const renderType = (type) => {
    let repaytype = '';
    if (type == 'payroll') {
      repaytype = 'Payroll';
    } else if (type == 'card') {
      repaytype = 'Card Payment';
    } else if (type == 'direct') {
      repaytype = 'Direct Debit';
    }
    return repaytype;
  };
  const renderProduct = (type) => {
    if (type == '3') {
      return 'Emergency';
    } if (type == '4') {
      return 'Payday';
    } if (type == '5') {
      return 'IPPIS';
    }
    return 'Unknown';
  };

  const renderStatus = (id, status) => {
    let statusButton = null;

    let className = 'info';
    let statusType = 'Unapproved';
    if (status === 5) {
      statusType = 'Approved';
      className = 'success';
    } else if (status === 3) {
      statusType = 'Modification Requested';
      className = 'secondary';
    } else if (status === 7) {
      statusType = 'Disbursed';
      className = 'primary';
    } else if (status === 9) {
      statusType = 'Rejected';
      className = 'danger';
    }
    statusButton = (
      <Button tag="a" size="sm" href={`/LoanDetails/${id}`} color={className}>{statusType}</Button>
    );
    return statusButton;
  };
  return (
    <tr>
      <th scope="row">{item.no}</th>
      <td>
        {' '}
        <Link to={{ pathname: `/clientdetails/${item.client._id}`, state: { client: item.client } }}>{item.clientId}</Link>
      </td>
      <td>
        {' '}
        {item.loanId}
      </td>
      <td>
        {' '}
        {numeral(item.loanAmount).format('0,0.00')}
      </td>
      {/* <td>
        {' '}
        {renderProduct(item.loanProductId)}
      </td> */}
      {/* <td>
        {' '}
        {renderType(item.repaymentOption)}
      </td> */}
      <td>
        {' '}
        {item.loanTenor}
      </td>
      <td>{moment(item.createdAt).format('lll')}</td>
      <td>
        {' '}
        {item.isTopup ? 'YES':'NO'}
      </td>
      <td>{renderStatus(item._id, item.status)}</td>
      <td>
        {' '}
        <Button onClick={() => item.close(item._id)} size="sm" disabled={item.closed} color="danger">Close on System</Button>
      </td>

      {/* <td>
        {' '}
        {item.user.employer == 'CHECKOFF' ? (
          <Button color="link" onClick={() => item.delete(item._id)} size="sm"><FontAwesome name="trash" style={{ color: '#c82590' }} /></Button>
        ) : <FontAwesome name="trash" style={{ color: '#000' }} />}

      </td> */}

    </tr>
  );
};

export default Loan;
